import { num } from "@/lib/api";

const oi = (v) => (v ? `${(v / 100000).toFixed(1)}L` : "—");

export const OptionChainTable = ({ chain, highlight, expiry, onExpiry }) => {
  if (!chain) return <div className="panel p-4 text-sm text-slate-500" data-testid="table-option-chain">Option chain unavailable.</div>;
  const hl = new Set(highlight || []);
  return (
    <div className="panel" data-testid="table-option-chain">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-800 px-4 py-2.5">
        <span className="eyebrow">Option chain · NIFTY</span>
        {hl.size > 0 && <span className="num text-[11px] text-indigo-300" data-testid="chain-highlight-legs">legs {[...hl].sort((a, b) => a - b).map((k) => num(k, 0)).join(" · ")}</span>}
        <select
          data-testid="select-expiry"
          value={expiry || chain.expiry}
          onChange={(e) => onExpiry(e.target.value)}
          className="num rounded border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-slate-200"
        >
          {(chain.expiries || []).map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
      </div>
      <div className="max-h-[360px] overflow-auto">
        <table className="dense num w-full">
          <thead className="sticky top-0 bg-[#0D121F]">
            <tr><th>CE OI</th><th>CE IV</th><th>CE LTP</th><th className="!text-center">Strike</th><th>PE LTP</th><th>PE IV</th><th>PE OI</th></tr>
          </thead>
          <tbody>
            {chain.rows.map((r) => {
              const atm = r.strike === chain.atm;
              return (
                <tr key={r.strike} data-testid={`chain-row-${r.strike}`} className={hl.has(r.strike) ? "!bg-indigo-500/10" : ""}>
                  <td className="text-slate-500">{oi(r.ce.oi)}</td>
                  <td className="text-slate-400">{num(r.ce.iv)}</td>
                  <td className="text-slate-100">{num(r.ce.ltp)}</td>
                  <td className={`!text-center font-semibold ${atm ? "text-indigo-300" : "text-slate-300"}`}>{num(r.strike, 0)}{atm && " ◆"}</td>
                  <td className="text-slate-100">{num(r.pe.ltp)}</td>
                  <td className="text-slate-400">{num(r.pe.iv)}</td>
                  <td className="text-slate-500">{oi(r.pe.oi)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
